import React from 'react'
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { IoMdArrowBack } from "react-icons/io";
import offers from "../../assets/img/custom/offers.jpg"
const Offers = () => {
    return (
        <>
            <button type="button" className="text-white btn btn-primary mx-4 my-3" onClick={() => window.history.back()}>
                <IoMdArrowBack /> Go Back
            </button>
            <div className="text-center">
<img src={offers} alt="" />
      </div>
        </>
    )
}

export default Offers
